'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { logSentryEvent } from '@libs/common-next/utils';
import { NAVIGATION_URLS } from '@libs/core';
import { SENTRY_CONTEXT } from '../../constants';
export function PageLoadLogger() {
  const $ = _c(3);
  const pathName = usePathname();
  const pagesSentryContextList = [{
    match: _temp,
    context: SENTRY_CONTEXT.CART_PAGE_LOADED
  }, {
    match: _temp2,
    context: SENTRY_CONTEXT.CHECKOUT_LOGIN_PAGE_LOADED
  }, {
    match: _temp3,
    context: SENTRY_CONTEXT.CHECKOUT_PAGE_LOADED
  }, {
    match: _temp4,
    context: SENTRY_CONTEXT.ORDER_CONFIRMATION_PAGE_LOADED
  }];
  const sentryContext = pagesSentryContextList.find(rule => rule.match(pathName || ""))?.context;
  let t0;
  if ($[0] !== sentryContext) {
    t0 = () => {
      if (sentryContext) {
        logSentryEvent("Page loaded", {
          sentryContext
        });
      }
    };
    $[0] = sentryContext;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp4(path_2) {
  return path_2?.startsWith(NAVIGATION_URLS.velocity.orderConfirmation);
}
function _temp3(path_1) {
  return path_1?.startsWith(NAVIGATION_URLS.velocity.checkout);
}
function _temp2(path_0) {
  return path_0?.startsWith(NAVIGATION_URLS.velocity.checkoutLogin);
}
function _temp(path) {
  return path?.startsWith(NAVIGATION_URLS.velocity.cart);
}